module.exports = __webpack_public_path__ + "icon_perhe.24fb6c3be4dc391b708a.svg";